<template>
  <div class="userFlowStep">
    <heading level="4" class="title">{{ $t('inReview.article.title') }}</heading>
    <div class="groupSteps">
      <div
        v-for="({ iconName, title, subtitle, description, status }, key) in steps"
        :key="key"
        :class="['step', status]"
      >
        <div class="image">
          <svg-use class="circle" name="Icons _ Circle" />
          <svg-use class="icon" :name="iconName" />
        </div>
        <div class="progress">
          <div class="line left"></div>
          <svg-use class="checkmark" name="Icons _ 01 System _ Action _ Check Circle" />
          <svg-use class="circle" name="Icons _ Stepper _ Future" />
          <svg-use class="disk" name="Icons _ Disk" />
          <div class="line right"></div>
        </div>
        <div class="title">{{ title }}</div>
        <div class="subtitle">{{ subtitle }}</div>
        <div class="description">{{ description }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'user-flow-step',
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style lang="sass" scoped>
$desktop-breakpoint: $tricera !default

$circle-size: baseunit(6)
$icon-size: baseunit(4)
$checkmark-size: baseunit(2.4)
$disk-size-small: baseunit(2.0)
$circle-size-small: baseunit(2.4)
$bar-height: baseunit(0.2)

.userFlowStep
  background: $glass-color-system-neutral-white
  border: 1px solid $color-system-neutral-gray-3
  border-radius: 4px
  padding: $glass-spacing-5
  width: 100%
  +mq($desktop-breakpoint)
    padding: $glass-spacing-3
    width: auto

.groupSteps
  display: flex
  justify-content: center
  margin-top: $glass-spacing-3
  flex-direction: column
  +mq($desktop-breakpoint)
    flex-direction: row

.progress
  .checkmark, .disk
    display: none

.line
  background-color: $glass-color-system-neutral-grey-07

  +mq($desktop-breakpoint)
    flex: 1 0 0
    height: 0
    margin-top: $checkmark-size / 2

  &.right
    margin-left: $glass-spacing-025

  &.left
    margin-right: $glass-spacing-025

.step
  position: relative
  width: 100%
  flex: 0 0 auto
  margin: 0 auto
  color: $glass-color-system-neutral-grey-07

  +mq($desktop-breakpoint)
    margin: 0
    width: baseunit(24.6)

  .image
    background: $glass-color-system-neutral-white
    position: relative
    width: $circle-size
    height: $circle-size
    margin: 0 auto

    .circle, .icon
      position: absolute

    .circle
      width: $circle-size
      height: $circle-size
      top: 0
      left: 0
      stroke: $glass-color-system-neutral-grey-09

    .icon
      color: $glass-color-system-neutral-grey-07
      width: $icon-size
      height: $icon-size
      top: ($circle-size - $icon-size) / 2
      left: ($circle-size - $icon-size) / 2

  &.complete,
  &.pending
    .line
      background-color: $color-primary-brand-light

    .progress
      .circle
        display: none

  &.complete
    .progress .checkmark
      display: block

  &.pending
    color: $glass-color-system-neutral-grey-09

    .progress .disk
      display: block

    .title
      font-weight: bold
      color: $color-system-neutral-gray-6

    .subtitle
      font-weight: bold
      color: $color-system-neutral-gray-5

    .line.right
      background-color: $glass-color-system-neutral-grey-07

    .image .icon
      color: $color-primary-brand-light

  &:not(:last-child)
    margin-bottom: $glass-spacing-4
    +mq($desktop-breakpoint)
      margin-bottom: 0

    .line.right
      height: $bar-height

  &:not(:first-child)
    .line.left
      height: $bar-height

  .title
    +font-size(16, 20)
    color: $color-system-neutral-gray-6

  .subtitle
    +font-size(13.33, 18)

  .description
    margin-top: $glass-spacing-2
    +font-size(13.33, 18)
    white-space: pre-wrap

.progress
  display: flex
  justify-content: center
  margin: $glass-spacing-1 0 $glass-spacing-05

  .checkmark
    background: $glass-color-system-neutral-white
    color: $color-primary-brand-light
    width: $checkmark-size
    height: $checkmark-size

  .disk
    width: $disk-size-small
    height: $disk-size-small
    margin: $glass-spacing-025 0

  .circle
    width: $circle-size-small
    height: $circle-size-small

  .disk
    color: $color-primary-brand-light
</style>
